/**
 * 答题题号
 */
export let THS = [
  '一',
  '二',
  '三',
  '四',
  '五',
  '六',
  '七',
  '八',
  '九',
  '十',
  '十一',
  '十二',
  '十三',
  '十四',
  '十五',
];
export let THSObj:any = {
  一: 1,
  二: 2,
  三: 3,
  四: 4,
  五: 5,
  六: 6,
  七: 7,
  八: 8,
  九: 9,
  十: 10,
  十一: 11,
  十二: 12,
  十三: 13,
  十四: 14,
  十五: 15,
};

// 小题号映射
export const xTHsMap: any = {
  '①':1,
  'a':1,
  'Ⅰ':1,
  '(1)':1,
  '②':2,
  'b':2,
  'Ⅱ':2,
  '(2)':2,
  '③':3,
  '④':4, '⑤':5, '⑥':6, '⑦':7, '⑧':8, '⑨':9, '⑩':10,
  'c': 3, 'd':4, 'e':5, 'f':6, 'g':7, 'h':8, 'i':9, 'j':10, 'k':11, 'l':12,
  'Ⅲ':3, 'Ⅳ':4, 'Ⅴ':5, 'Ⅵ':6, 'Ⅶ':7, 'Ⅷ':8, 'Ⅸ':9, 'Ⅹ':10, 'Ⅺ':11, 'Ⅻ':12,
  '(3)': 3, '(4)':4, '(5)':5, '(6)':6, '(7)':7, '(8)':8, '(9)':9, '(10)':10, '(11)':11, '(12)':12
}

/**
 * 1栏，2栏，3栏宽度
 * 706代表 1栏2栏宽度
 * 505代表 3栏宽度
 * */

export const PAGE_SIZE_CELL = [706, 505];
export const TAG_110_HEIGHT = 110; // 一个客观题的高度
export const editorHeightTAG_P_HEIGHT = 38; // 一个p元素的固定高度
export const TAG_P_HEIGHT = 38; // 一个p元素的固定高度
export const PADDING_TOP = 16; // 一个内边距的值
export const MARGIN_BOTTOM = 10;
export const PAGE_CELL_HEIGHT = 966; //1007-966 615-41
export const CONTENT_HEIGHT = 574; //
export const PAGE_LAYOUT_TOP = 1113; //
// export const KONGGE_ELEMENT = '<span class="zwq" style="text-decoration: underline">'
export const KONGGE_ELEMENT = '</span>';
export const KONGGE_ELEMENT_UNDERLINE = '<span style="text-decoration: underline;">'
export const WHITE_SPACE_NBSP = '<span style="white-space: normal;text-decoration: underline">&nbsp';
export const WHITE_SPACE_NONBSP = '<span style="white-space: normal;text-decoration: underline">';



/**
 * A - Z tab列表
 * */

export const TABS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];
/**
 * ckeditor 编辑器配置信息
 */
export const CKEDITOR_CONFIG = {
  toolbar: [
    'Bold',
    'Italic',
    'Underline',
    'Alignment',
    'Subscript',
    'Superscript',
    'SpecialCharacters',
    'MathType',
    'Link',
    'BlockQuote',
    'BulletedList',
    'NumberedList',
    'ImageUpload',
    'InsertTable',
    'Undo',
    'Redo',
  ],
  heading: {
    options: [
      { model: 'paragraph', title: '标准', class: 'ck-heading_paragraph' },
      {
        model: 'heading1',
        view: 'h1',
        title: 'h1',
        class: 'ck-heading_heading1',
      },
      {
        model: 'heading2',
        view: 'h2',
        title: 'h2',
        class: 'ck-heading_heading2',
      },
    ],
  },
};

export const UEDITOR_CONFIG = {
  // 你的UEditor资源存放的路径,相对于打包后的index.html

  UEDITOR_HOME_URL: './UEditor/',
  // 编辑器不自动被内容撑高
  // autoHeightEnabled: false,
  // 初始容器高度
  initialFrameHeight: '100%',
  // 初始容器宽度
  initialFrameWidth: '100%',
  enableAutoSave: false,
  saveInterval: false,
  serverUrl: '/api/CardQuest/UploadFile',
  // serverUrl: 'http://35.201.165.105:8000/controller.php', // 图片上传暂时实现有点麻烦
  // 自定义工具栏，需要额外选项可以参考ueditor.config.js
  toolbars: [
    [
      'fontsize',
      '|',
      'undo',
      'redo',
      '|',
      'cuihovah',
      'latex',
      'ptag',
      'bold',
      'underline',
      'superscript',
      'subscript',
      'removeformat',
      'imagePopup',
      'simpleupload',
      '|',
      'lineheight',
      '|',
      'directionalityltr',
      'directionalityrtl',
      // 'indent',
      '|',
      'inserttable',
      'deletetable',
      'horizontal',
      '|',
      'justifyleft',
      'justifycenter',
      'justifyright',
      'justifyjustify',
    ],
  ],
  fontsize: [10, 11, 12, 13, 14, 18, 20, 24, 36],
  initialFontSize: 10,
  isShow: true,
  elementPathEnabled: false,
  wordCount: false,
  autoFloatEnabled: false,
  scaleEnabled: false,
  initialStyle: `p{line-height:${TAG_P_HEIGHT}px;}`,
};
export const UEDITOR_CONFIG_BLANK = {
  // 你的UEditor资源存放的路径,相对于打包后的index.html

  UEDITOR_HOME_URL: './UEditor/',
  // 编辑器不自动被内容撑高
  // autoHeightEnabled: true,
  // 初始容器高度
  initialFrameHeight: '100%',
  // 初始容器宽度
  initialFrameWidth: '100%',
  enableAutoSave: false,
  saveInterval: false,
  serverUrl: '/api/CardQuest/UploadFile',
  // serverUrl: 'http://35.201.165.105:8000/controller.php', // 图片上传暂时实现有点麻烦
  // 自定义工具栏，需要额外选项可以参考ueditor.config.js
  toolbars: [
    [
      'fontsize',
      '|',
      'undo',
      'redo',
      '|',
      'cuihovah',
      'latex',
      'ptag',
      'bold',
      'underline',
      'superscript',
      'subscript',
      'removeformat',
      'imagePopup',
      'simpleupload',
      '|',
      'lineheight',
      '|',
      'directionalityltr',
      'directionalityrtl',
      // 'indent',
      '|',
      'inserttable',
      'deletetable',
      'horizontal',
      '|',
      'justifyleft',
      'justifycenter',
      'justifyright',
      'justifyjustify',
    ],
  ],
  fontsize: [10, 11, 12, 13, 14, 18, 20, 24, 36],
  initialFontSize: 10,
  isShow: true,
  elementPathEnabled: false,
  wordCount: false,
  autoFloatEnabled: false,
  scaleEnabled: false,
  initialStyle: `p{line-height:${TAG_P_HEIGHT}px;}`,
};

export const UEDITOR_CONFIG_BLANK_SCORE = {
  // 你的UEditor资源存放的路径,相对于打包后的index.html

  UEDITOR_HOME_URL: './UEditor/',
  // 编辑器不自动被内容撑高
  // autoHeightEnabled: true,
  // 初始容器高度
  initialFrameHeight: '100%',
  // 初始容器宽度
  initialFrameWidth: '100%',
  enableAutoSave: false,
  saveInterval: false,
  serverUrl: '/api/CardQuest/UploadFile',
  // serverUrl: 'http://35.201.165.105:8000/controller.php', // 图片上传暂时实现有点麻烦
  // 自定义工具栏，需要额外选项可以参考ueditor.config.js
  toolbars: [
    [
      'fontsize',
      '|',
      'undo',
      'redo',
      '|',
      'cuihovah',
      'latex',
      'ptag',
      'bold',
      'superscript',
      'subscript',
      'imagePopup',
      '|',
      'lineheight',
      '|',
      'directionalityltr',
      'directionalityrtl',
      // 'indent',
      '|',
      'inserttable',
      'deletetable',
      'horizontal',
      '|',
      'justifyleft',
      'justifycenter',
      'justifyright',
      'justifyjustify',
    ],
  ],
  fontsize: [10, 11, 12, 13, 14, 18, 20, 24, 36],
  initialFontSize: 10,
  isShow: true,
  elementPathEnabled: false,
  wordCount: false,
  autoFloatEnabled: false,
  scaleEnabled: false,
  initialStyle: `p{line-height:${TAG_P_HEIGHT}px;}`,
};

export const UEDITOR_CONFIG_TITLE = {
  // 你的UEditor资源存放的路径,相对于打包后的index.html

  UEDITOR_HOME_URL: './UEditor/',
  // 编辑器不自动被内容撑高
  // autoHeightEnabled: false,
  // 初始容器高度
  initialFrameHeight: '66',
  // 初始容器宽度
  initialFrameWidth: '100%',
  enableAutoSave: false,
  saveInterval: false,
  serverUrl: '/api/CardQuest/UploadFile',
  // serverUrl: 'http://35.201.165.105:8000/controller.php', // 图片上传暂时实现有点麻烦
  // 自定义工具栏，需要额外选项可以参考ueditor.config.js
  toolbars: [
    [
      'fontsize',
      '|',
      'undo',
      'redo',
      '|',
      'bold',
      'underline',
     
    ],
  ],
  
  fontsize: [10, 11, 12, 13, 14, 18, 20, 24, 36],
  initialFontSize: 10,
  isShow: true,
  elementPathEnabled: false,
  wordCount: false,
  autoFloatEnabled: false,
  scaleEnabled: false,
  initialStyle: `p{line-height:22px;min-height: 22px; text-align: center;font-size:16px}`,
};

export const DEFAULT_PAGECELL = [
  {
    //  答题卡页面的布局
    layout: {
      width: PAGE_SIZE_CELL[0],
      height: PAGE_CELL_HEIGHT,
      position: 'absolute',
      top: 10,
      left: '50%',
      padding: '62px 44px',
      marginLeft: -353,
    },
    // 每种题型的内容高度（就是去除纸张上面考生信息的高度）
    contentHeight: CONTENT_HEIGHT,
    items: [],
    // 填空题
    fillTopiclist: [],
  },
];
